import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as H from "helper";

const useStyles = makeStyles((theme) => ({
  box: { marginTop: theme.spacing(2), marginLeft: theme.spacing(1), borderRight: "1px solid #dcdcdc" },
  boxLast: { marginTop: theme.spacing(2), marginLeft: theme.spacing(1) },
  title: { display: "block", height: 32, fontSize: 14 },
  value: { paddingTop: 0, paddingBottom: 0, minWidth: 150 },
}));

const ByAreaCheckInSummary = ({ data, periodUniqueUsers }) => {
  const classes = useStyles();
  const items = [
    ["合計登録エリア数", data?.registeredAreaCount],
    ["合計未チェックインエリア数", data?.uncheckedAreaCount],
    ["合計登録数", data?.totalRegistered],
    ["合計チェックイン数", data?.totalCheckin],
    ["チェックイン対象アセット数", data?.totalCheckinAssets],
    ["合計達成率(%)", data?.totalAchievementRate === undefined ? undefined : `${data.totalAchievementRate.toFixed(2)}%`],
    ["合計チェックイン者数", periodUniqueUsers],
  ];

  if (!data) return null;

  return (
    <Grid container spacing={1}>
      {items.map(([title, value], index) => (
        <Grid item sm={6} md={4} lg={index === items.length - 1 ? 2 : 2} key={title}>
          <div className={index === items.length - 1 ? classes.boxLast : classes.box}>
            <Typography variant="caption" className={classes.title}>{title}</Typography>
            <Typography variant="h6" className={classes.value}>
              {value === undefined || value === null ? "-" : typeof value === "string" ? value : H.FormatNumStrHelper.formatCommaThousand(value)}
            </Typography>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default ByAreaCheckInSummary;
